var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useEffect, useRef } from "react";
import { UuiInput } from "@aonunited/react";
import "./AonInput.component.scss";
import React from "react";
var AonInput = function (_a) {
    var label = _a.label, required = _a.required, type = _a.type, children = _a.children, props = __rest(_a, ["label", "required", "type", "children"]);
    var inputRef = useRef(null);
    var removeNumberEvent = function (e) {
        if (type === "number") {
            // Allows 0-9 and numpad 0-9, backspace, delete, enter, left, right, decimal point for number field
            var allowedKeys = [
                8, 9, 13, 37, 39, 46, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57,
                96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 110, 190
            ];
            if (e.type === "wheel" || (e.type === "keydown" && !allowedKeys.includes(e.keyCode))) {
                e.preventDefault();
            }
        }
    };
    useEffect(function () {
        var inputElement = inputRef.current;
        if (inputElement !== null) {
            inputElement.addEventListener("wheel", removeNumberEvent, { passive: false });
        }
        return function () {
            if (inputElement) {
                inputElement.removeEventListener("wheel", removeNumberEvent);
            }
        };
    }, []);
    return (React.createElement("div", null,
        label && required ? React.createElement("div", { style: { paddingBottom: "5px" } },
            React.createElement("span", null,
                label,
                React.createElement("span", { style: { color: "red" } }, "*"))) : label && React.createElement("div", { style: { paddingBottom: "5px" } },
            React.createElement("span", null, label)),
        React.createElement(UuiInput, __assign({ ref: inputRef, className: "aon-input", type: type }, props, { onKeyDown: type === "number" ? removeNumberEvent : undefined }), children)));
};
export default AonInput;
